import styled from 'styled-components';
import colors from '../../theme/search/colors';

const Wrapper = styled.div`
  width: 100%;
  position: relative;
  z-index: 1;

  .range-container {
    width: ${props => props.width};
    padding: 20px;
    display: flex;
    justify-content: center;
    position: relative;
    z-index: 10;
    pointer-events: auto;
    margin: 0 auto;
  }

  & .input-zone {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 350px;
  }

  input {
    width: 56px;
    height: 27px;
    box-sizing: border-box;
    border: 1px solid #cecece;
    outline: none;
    font-size: 14px;
    margin: 20px;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 0;
    padding: 2px;
    text-align: center;
    background: transparent;
  }

  /* rc-slider base styles (embedded to avoid CSS import issues in production) */
  .rc-slider {
    position: relative;
    height: 40px;
    padding: 5px 0;
    width: 100%;
    border-radius: 6px;
    touch-action: none;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    pointer-events: auto;
  }

  .rc-slider * {
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .rc-slider-rail {
    position: absolute;
    width: 100%;
    height: 3px;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 6px;
    background-color: #e9e9e9;
  }

  .rc-slider-track {
    position: absolute;
    height: 3px;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    border-radius: 6px;
  }

  .rc-slider-step {
    position: absolute;
    width: 100%;
    height: 4px;
    background: transparent;
  }

  .rc-slider-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    cursor: pointer;
    cursor: grab;
    border-radius: 50%;
    border: solid 2px #96dbfa;
    background-color: #fff;
    touch-action: pan-x;
    top: 50%;
    margin-top: -10px;
    pointer-events: auto;
  }

  .rc-slider-handle:focus {
    outline: none;
  }

  .rc-slider-handle:active {
    cursor: grabbing;
  }

  .rc-slider-mark {
    position: absolute;
    top: 18px;
    left: 0;
    width: 100%;
    font-size: 12px;
  }
`;

const handleStyle = {
  border: `2px solid ${colors.greyTwo}`,
  backgroundColor: colors.offWhite
};

const trackStyle = {
  backgroundColor: colors.slider,
  height: 3
};

const railStyle = {
  backgroundColor: colors.borderSelect,
  height: 3
};

export { Wrapper, handleStyle, trackStyle, railStyle };



// WEBPACK FOOTER //
// ./src/components/YearSelect/style.js